import { AlertRepository } from "../../repositories/AlertRrepository";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  Divider,
  FormControl,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Stack,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Accordion,
  AccordionActions,
  AccordionSummary,
  AccordionDetails,
  Badge,
} from "@mui/material";
import { alpha, useMediaQuery, useTheme } from "@mui/system";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { notifyShowErrorMessage } from "../../common/CommonActions";
import { ErrorMessageResolver } from "../../common/ErrorMessageResolver";
import { LOCALE } from "../../properties/Locale";
import { LocalizationProvider } from "@mui/lab";
import { LocalizationProvider as LocalizationProvider1 } from "@mui/x-date-pickers";
import { DateCreatedCalendar } from "../tickets/DateCreatedCalendar";
import { addDays } from "date-fns";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Draggable from "react-draggable";
import { UsersRepository } from "../../repositories/UsersRepository";
import { OrganizationsRepository } from "../../repositories/OrganizationsRepository";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/en-gb";
import { EloMessageRepository } from "../../repositories/EloMessageRepository";
import { AuthRepository } from "../../repositories/AuthRepository";
import axios from "axios";
import { SETTINGS } from "../../properties/Settings";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export const EloMessage = () => {
  const theme = useTheme();
  const [data, setData] = React.useState([]);
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const response = await AlertRepository.getAllActiveByType({ type: "ELO" });
        setAlerts(response.data);
      } catch (error) {
        console.error("Failed to fetch alerts: ", error);
      }
    };
    fetchAlerts();
  }, []);
  const defaultColors = {
    success: { bg: "#edf7ed", text: "#1e4620", icon: "#2e7d32" },
    error: { bg: "#fdecea", text: "#611a15", icon: "#d32f2f" },
    warning: { bg: "#fff4e5", text: "#663c00", icon: "#ed6c02" },
    info: { bg: "#e8f4fd", text: "#014361", icon: "#0288d1" },
  };


  const [users, setUsers] = React.useState();
  const [usersSearch, setUsersSearch] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const params = useParams();
  const { id } = useParams();
  const [size, setSize] = React.useState(15);
  const [page, setPage] = React.useState(0);
  const [searchParams, setSearchParams] = React.useState({});
  const [expanded, setExpanded] = useState(false);
  const [openDateCreatedCalendar, setOpenDateCreatedCalendar] =
    React.useState(false);
  const [organizationSearch, setOrganizationSearch] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [hoveredRow, setHoveredRow] = React.useState(null);
  const [currUser, setCurrUser] = React.useState(null);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [highlightedRow, setHighlightedRow] = useState(sessionStorage.getItem("highlightedRow"));

  const orderByRef = React.useRef("status");
  const orderDirectionRef = React.useRef("ASC");
  const didMountRef = React.useRef(false);

  const globalState = useSelector((state) => state);
  React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const uuidToColor = (uuid) => {
    // Extract a portion of the UUID to use as the seed
    let seed = parseInt(uuid.slice(0, 8), 16);

    // Generate random RGB values based on the seed
    let random = () => {
      let x = Math.sin(seed++) * 10000;
      return (x - Math.floor(x)) * 256;
    };
    let r = Math.floor(random());
    let g = Math.floor(random());
    let b = Math.floor(random());

    // Convert RGB values to CSS color representation
    let cssColor = `rgb(${r}, ${g}, ${b})`;
    return cssColor;
  };

  useEffect(() => {
    if (params?.orderBy === "dateCreated" && !didMountRef.current) {
      navigate(`/eloMessage/0/${params?.size ?? 15}/${params?.params ?? "{}"}/status/ASC`);
    }
  }, []);

  useEffect(() => {
    const currentUser = AuthRepository.getUserDetails();
    if (currentUser?.organization?.id) {
      setSearchParams((prev) => ({
        ...prev,
        "organization.id": currentUser.organization.id,
      }));
    }
  }, []);

  const capitalizeFirstLetter = (val) => {
    return String(val)?.charAt(0)?.toUpperCase() + String(val)?.slice(1);
  };

  const handleChange = (name, value) => {
    let tmp = { ...searchParams };
    tmp[name] = value;
    setSearchParams(tmp);
  };

  const handleChangePage = (event, newPage) => {
    navigate(
      `/eloMessage/${newPage}/${params?.size}/${JSON.stringify(
        JSON.parse(params.params),
      )}/${params?.orderBy}/${params?.orderDirection}`,
    );
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setSize(parseInt(event.target.value, 10));
    navigate(
      `/eloMessage/${0}/${event.target.value}/${JSON.stringify(
        JSON.parse(params.params),
      )}/${params?.orderBy}/${params?.orderDirection}`,
    );
  };

  const loadData = (page, size, orderBy, orderDirection, searchParams) => {
  setLoading(true);
  
  let tmp;
    try {
      if (!searchParams) {
        tmp = "{}";
      } else if (typeof searchParams === "object") {
        tmp = JSON.stringify(searchParams);
      } else {
        const parsed = JSON.parse(searchParams);
        tmp = JSON.stringify(parsed);
      }
    } catch (e) {
      tmp = "{}";
    }

    EloMessageRepository.getAll({
      page: page ?? 0,
      size: size ?? 15,
      orderBy: orderBy ?? "status",
      orderDirection: orderDirection ?? "ASC",
      searchParams: tmp,
    })
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(err)));
        setLoading(false);
      });
  };

  useEffect(() => {
    if (id) return;
    if(!didMountRef.current){
      didMountRef.current = true;
      return;
    }
    const timer = setTimeout(() => {
      navigate(
        `/eloMessage/${params?.page}/${params?.size}/${JSON.stringify(searchParams)}/${orderByRef.current}/${orderDirectionRef.current}`,
      );
    }, 500);
    return () => clearTimeout(timer);
  }, [searchParams, id]);

  useEffect(() => {
    orderByRef.current = params?.orderBy ?? "status";
    orderDirectionRef.current = params?.orderDirection ?? "ASC";
  }, [params?.orderBy, params?.orderDirection]);

  useEffect(() => {
    const id = sessionStorage.getItem("highlightedRow");
    if (id) {
      setHighlightedRow(id);
    }
  }, []);

  const getUsers = () => {
    setLoading(true);
    UsersRepository.getAllUsersByResponsibleOffice()
      .then((response) => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (params && params.page !== undefined && params.size) {
      loadData(
        params?.page,
        params?.size,
        params?.orderBy,
        params?.orderDirection,
        params?.params,
      );
    }
    if (params.params) {
      try {
        setSearchParams(JSON.parse(params.params));
      } catch (e) {
        setSearchParams({});
      }
    }
  }, [
    params?.page,
    params?.size,
    params?.params,
    params?.orderBy,
    params?.orderDirection,
    globalState.triggerRerender,
  ]);

  const fromDateCreated = new Date(searchParams.fromDayCreated);
  const formattedFromDateCreated = fromDateCreated.toString().substring(4, 15);
  const toDateCreated = new Date(searchParams.toDayCreated);
  const formattedToDateCreated = toDateCreated.toString().substring(4, 15);

  const handleDateCreatedCalendar = () => {
    setOpenDateCreatedCalendar(true);
  };

  const handleDateCreated = () => {
    {
      let fromDayCreated = "fromDayCreated";
      let toDayCreated = "toDayCreated";
      dateCreatedState.map((dateCreatedState) => {
        let start = moment(dateCreatedState.startDate).toString();
        let end = moment(dateCreatedState.endDate).toString();
        let tmp = { ...searchParams };
        tmp[fromDayCreated] = start;
        tmp[toDayCreated] = end;
        setSearchParams(tmp);
      });
    }
  };

  const [dateCreatedState, setDateCreatedState] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);

  const checkNumberOfFilters = () => {
    let numberOfFilters = 0;
    Object.keys(searchParams).forEach((key) => {
      if (
        searchParams[key] !== undefined &&
        searchParams[key] !== "" &&
        searchParams[key] !== null
      ) {
        numberOfFilters++;
      }
    });
    return numberOfFilters;
  };

  const handleDownloadElo = (id, mrn) => {
    setLoading(true);

    axios({
      url: `${SETTINGS.API_URL}eloMessage/download/${id}`,
      method: "GET",
      responseType: "blob",
    })
      .then((res) => {
        // Extract the filename from the `content-disposition` header
        console.log(res);
        const contentDisposition = res.headers["content-disposition"];
        let filename = mrn + ".pdf"; // Default filename
        console.log("test");
        if (contentDisposition) {
          console.log("test2");
          const match = contentDisposition.match(
            /filename\*?=['"]?(?:UTF-8['"]*)?([^;'"]+)/i,
          );
          if (match && match[1]) {
            console.log(match[1]);
            filename = decodeURIComponent(match[1]);
          }
        }

        // Create a Blob from the response data
        const file = new Blob([res.data], {
          type: "application/pdf",
        });

        // Create a downloadable link
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = filename; // Set the filename
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);

        setLoading(false);
      })
      .catch((err) => {
        dispatch(notifyShowErrorMessage(err.message));
        setLoading(false);
      });
  };

  const handleClickChangeOrderBy = (field) => {
    const currentOrderBy = orderByRef.current;
    const currentDirection = orderDirectionRef.current;

    let newOrderBy;
    let newDirection;

    if (currentOrderBy === field) {
      newDirection = currentDirection === "ASC" ? "DESC" : "ASC";
      newOrderBy = field;
    } else {
      newOrderBy = field;
      newDirection = "DESC";
    }

    orderByRef.current = newOrderBy;
    orderDirectionRef.current = newDirection;

    navigate(
      `/eloMessage/0/${params?.size}/${params?.params}/${newOrderBy}/${newDirection}`
    );
  };

  return (
    <>
      <Grid container>
        {alerts.map((alert) => (
          <Grid item xs={12} sx={{ marginBottom: 2 }} key={alert.id}>
            <Alert
              severity={alert.severity}
              sx={{
                fontSize: "0.9rem",
                backgroundColor: defaultColors[alert.severity].bg,
                color: defaultColors[alert.severity].text,
                "& .MuiAlert-icon": {
                  color: defaultColors[alert.severity].icon,
                },
              }}
            >
              {alert.description}
            </Alert>
          </Grid>
        ))}

        <Grid item xs={12} md={4}>
          <Stack
            direction="row"
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography
              variant="h5"
              key="2"
              color="text.primary"
              sx={{
                fontWeight: "bold",
                typography: { xs: "h4", md: "h5" },
                alignContent: "center",
                marginLeft: { xs: "8px", md: "0px" },
              }}
            >
              ELO
              <IconButton
                onClick={() => loadData()}
                sx={{
                  border: "1px solid lightGray",
                  borderRadius: "5px",
                  padding: "1px",
                  minWidth: "auto",
                  height: "auto",
                  marginLeft: "5px",
                  display: { xs: "none", md: "inline-flex" },
                }}
              >
                <Icon
                  style={{ color: theme.palette.darkContrast.main }}
                  fontSize="20"
                >
                  refresh
                </Icon>
              </IconButton>
              <IconButton
                onClick={() => navigate(window.location.pathname + "/new")}
                sx={{
                  border: "1px solid lightGray",
                  borderRadius: "5px",
                  padding: "1px",
                  minWidth: "auto",
                  height: "auto",
                  marginLeft: "5px",
                  display: { xs: "none", md: "inline-flex" },
                }}
              >
                <Icon
                  style={{ color: theme.palette.darkContrast.main }}
                  fontSize="20"
                >
                  add
                </Icon>
              </IconButton>
            </Typography>
            <Box
              sx={{
                display: { xs: "inline-flex", md: "none", marginRight: "11px" },
              }}
            >
              <IconButton
                onClick={() => loadData()}
                sx={{
                  border: "1px solid lightGray",
                  borderRadius: "5px",
                  padding: "1px",
                  minWidth: 55,
                  height: 55,
                  marginLeft: "5px",
                }}
              >
                <Icon
                  style={{
                    color: theme.palette.darkContrast.main,
                    fontSize: "28px",
                  }}
                >
                  refresh
                </Icon>
              </IconButton>
              <IconButton
                onClick={() => navigate(window.location.pathname + "/new")}
                sx={{
                  border: "1px solid lightGray",
                  borderRadius: "5px",
                  padding: "1px",
                  minWidth: 55,
                  height: 55,
                  marginLeft: "5px",
                }}
              >
                <Icon
                  style={{
                    color: theme.palette.darkContrast.main,
                    fontSize: "28px",
                  }}
                >
                  add
                </Icon>
              </IconButton>
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={12} sx={{ paddingTop: 2 }}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Accordion
            style={{
              boxShadow: "none",
              backgroundColor: "transparent",
            }}
            expanded={expanded}
          >
            <AccordionSummary
              style={{
                cursor: "default",
                backgroundColor: theme.palette.dashboardBackground.main,
              }}
            >
              <Grid container alignItems="center" sx={{ width: "100%" }}>
                {/* Filters button - left side */}
                <Grid item xs={4} md={2}>
                  {isSmallScreen ? (
                    <Box sx={{ width: "100%", position: "relative" }}>
                      <Button
                        fullWidth
                        color="primary"
                        variant={expanded ? "contained" : "outlined"}
                        onClick={() => setExpanded(!expanded)}
                        sx={{
                          height: "50px",
                          fontSize: "15px",
                          marginTop: "16px",
                        }}
                        endIcon={
                          expanded ? (
                            <Tooltip
                              title={"Clear filters"}
                              arrow
                              placement="right"
                            >
                              <IconButton
                                size="small"
                                sx={{
                                  color: theme.palette.dashboardBackground.main,
                                  fontSize: "15px",
                                  width: "10px",
                                  marginLeft: "5px",
                                }}
                                onClick={() => {
                                  setSearchParams({});
                                  navigate(
                                    `/eloMessage/${params.page}/${params.size}/${JSON.stringify({})}/${params?.orderBy}/${params?.orderDirection}`,
                                  );
                                }}
                              >
                                <Icon>clear</Icon>
                              </IconButton>
                            </Tooltip>
                          ) : null
                        }
                      >
                        F
                        <span style={{ textTransform: "lowercase" }}>
                          ilters
                        </span>
                      </Button>
                      {checkNumberOfFilters() > 0 && (
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: -8,
                            right: -8,
                            backgroundColor: theme.palette.primary.main,
                            color: "white",
                            borderRadius: 1,
                            fontSize: "12px",
                            padding: "0 6px",
                            minWidth: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid",
                            borderColor: expanded
                              ? theme.palette.dashboardBackground.main
                              : "none",
                          }}
                        >
                          {checkNumberOfFilters()}
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Button
                      color="primary"
                      variant={expanded ? "contained" : "outlined"}
                      onClick={() => setExpanded(!expanded)}
                      style={{
                        transition: "width 0.3s ease",
                        width: expanded ? "125px" : "100px",
                        height: "50px",
                        fontSize: "15px",
                        marginTop: "16px",
                      }}
                      endIcon={
                        expanded ? (
                          <Tooltip
                            title={"Clear filters"}
                            arrow
                            placement="right"
                          >
                            <IconButton
                              size="small"
                              sx={{
                                color: theme.palette.dashboardBackground.main,
                                fontSize: "15px",
                                width: "10px",
                                marginLeft: "5px",
                              }}
                              onClick={() => {
                                setSearchParams({});
                                navigate(
                                  `/eloMessage/${params.page}/${params.size}/${JSON.stringify({})}/${params?.orderBy}/${params?.orderDirection}`,
                                );
                              }}
                            >
                              <Icon>clear</Icon>
                            </IconButton>
                          </Tooltip>
                        ) : (
                          ""
                        )
                      }
                    >
                      F
                      <span style={{ textTransform: "lowercase" }}>ilters</span>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails
              style={{
                paddingLeft: isSmallScreen ? "9px" : "1px",
                marginRight: isSmallScreen ? "-5px" : "0px",
                backgroundColor: theme.palette.dashboardBackground.main,
                marginTop: "-18px",
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12} md={1.7} lg={1.2}>
                  <TextField
                    onChange={(e) =>
                      handleChange(
                        "internalReference",
                        e.target.value.trim().replace(/[^a-z0-9-]/gi, ""),
                      )
                    }
                    label={"Internal Reference"}
                    value={
                      searchParams?.internalReference
                        ? searchParams?.internalReference
                        : ""
                    }
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={1.7} lg={1.2}>
                  <FormControl fullWidth>
                    <InputLabel>Direction</InputLabel>
                    <Select
                      label="Direction"
                      value={
                        searchParams?.sensTraversee
                          ? searchParams?.sensTraversee
                          : ""
                      }
                      onChange={(event) => {
                        handleChange("sensTraversee", event.target.value);
                      }}
                      color="lightGray"
                      disabled={loading}
                      style={{
                        width: "100%",
                        fontSize: "12px",
                        borderRadius: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      <MenuItem value="IMPORT">
                        <span style={{ marginLeft: 10 }}>{"IMPORT"}</span>
                      </MenuItem>
                      <MenuItem value="EXPORT">
                        <span style={{ marginLeft: 10 }}>{"EXPORT"}</span>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={1.7} lg={1.2}>
                  <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                      label="Status"
                      value={searchParams?.status ? searchParams?.status : ""}
                      onChange={(event) => {
                        handleChange("status", event.target.value);
                      }}
                      color="lightGray"
                      disabled={loading}
                      style={{
                        width: "100%",
                        fontSize: "12px",
                        borderRadius: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      <MenuItem value="CREATED">
                        <span style={{ marginLeft: 10 }}>{"CREATED"}</span>
                      </MenuItem>
                      <MenuItem value="SENT">
                        <span style={{ marginLeft: 10 }}>{"SENT"}</span>
                      </MenuItem>
                      <MenuItem value="PAIRED">
                        <span style={{ marginLeft: 10 }}>{"PAIRED"}</span>
                      </MenuItem>
                      <MenuItem value="EMBARKED">
                        <span style={{ marginLeft: 10 }}>{"EMBARKED"}</span>
                      </MenuItem>
                      <MenuItem value="DEBARKED">
                        <span style={{ marginLeft: 10 }}>{"DEBARKED"}</span>
                      </MenuItem>
                      <MenuItem value="COMPLETED">
                        <span style={{ marginLeft: 10 }}>{"COMPLETED"}</span>
                      </MenuItem>
                      <MenuItem value="ERROR">
                        <span style={{ marginLeft: 10 }}>{"ERROR"}</span>
                      </MenuItem>
                      <MenuItem value="REJECTED">
                        <span style={{ marginLeft: 10 }}>{"REJECTED"}</span>
                      </MenuItem>
                      <MenuItem value="DRAFT">
                        <span style={{ marginLeft: 10 }}>{"DRAFT"}</span>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>

        {/* Mobile card list */}
        <Grid
          item
          xs={12}
          sx={{
            display: {
              xs: "block",
              md: "none",
            },
            height: "75vh",
            overflowY: "auto",
            scrollbarWidth: "none", 
            "&::-webkit-scrollbar": {
              display: "none", 
            },
          }}
        >
          <Table
            sx={{
              borderSpacing: "8px",
              borderCollapse: "separate",
              paddingBottom: "10px",
            }}
          >
            <TableBody>
              {loading
                ? Array.from({ length: parseInt(params?.size) || 15 }).map(
                    (_, index) => (
                      <TableRow key={index}>
                        <TableCell colSpan={14} sx={{ padding: "12px 16px" }}>
                          <Skeleton
                            variant="rounded"
                            width="100%"
                            height={25}
                            animation="wave"
                          />
                        </TableCell>
                      </TableRow>
                    ),
                  )
                : data &&
                  data?.totalElements > 0 &&
                  data?.content?.map((item, index) => (
                    <TableRow key={index} style={{backgroundColor: item?.seen === false ? "rgb(66 185 178 / 21%)" : ""}}>
                      <TableCell
                        colSpan={13}
                        sx={{ padding: { xs: 1, sm: 2 } }}
                      >
                        <Grid container spacing={1}>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Date Created
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "light", fontSize: "16px" }}
                            >
                              {item?.dateCreated
                                ? moment(item?.dateCreated).format(
                                    "DD.MM.YYYY HH:mm",
                                  )
                                : "N/A"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Client
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "light", fontSize: "16px" }}
                            >
                              {`${item?.organization?.nameEn}`}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              User
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "light", fontSize: "16px" }}
                            >
                              {item?.createdBy?.displayName
                                ? item?.createdBy?.displayName
                                : "N/A"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Internal Reference
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "light", fontSize: "16px" }}
                            >
                              {`${item?.internalReference}`}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Direction
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "light", fontSize: "16px" }}
                            >
                              {`${item?.informationsAppairage?.sensTraversee}`}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Status
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Chip
                              label={item?.status ? item?.status : "N/A"}
                              size="small"
                              color={
                                item?.status === "ERROR" ||
                                item?.status === "REJECTED"
                                  ? "error"
                                  : item?.status === "COMPLETED"
                                    ? "success"
                                    : "primary"
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              ELO Number
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "light", fontSize: "16px" }}
                            >
                              {item?.eloNumber ? item?.eloNumber : "N/A"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Reference Number
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: "light", fontSize: "16px" }}
                            >
                              {item?.referenceNumber
                                ? item?.referenceNumber
                                : "N/A"}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sx={{ textAlign: "right" }}>
                            {item?.status && item?.status === "COMPLETED" && (
                              <Tooltip title="Download ELO">
                                <IconButton
                                  onClick={() => {
                                    handleDownloadElo(item?.id);
                                  }}
                                >
                                  <Icon
                                    style={{
                                      color: theme.palette.secondary.main,
                                    }}
                                    fontSize="large"
                                  >
                                    get_app
                                  </Icon>
                                </IconButton>
                              </Tooltip>
                            )}
                            <Tooltip title={LOCALE.edit}>
                              <IconButton
                                onClick={() => {
                                  navigate(
                                    window.location.pathname +
                                      "/edit/" +
                                      item?.id,
                                  );
                                }}
                              >
                                <Icon
                                  style={{
                                    color: theme.palette.primary.main,
                                  }}
                                  fontSize="large"
                                >
                                  open_in_new
                                </Icon>
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
            <TableFooter
              style={{
                position: "fixed",
                bottom: 0,
                zIndex: 5,
                backgroundColor: theme.palette.background.paper,
                width: "100%",
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <TableRow>
                <TableCell colSpan={20} sx={{ borderBottom: "none" }}>
                  <Grid item xs={12} justifyContent="center"></Grid>
                  <Grid
                    container
                    sx={{
                      marginBottom: "10px",
                    }}
                  >
                    <Grid item xs={12}>
                      <Pagination
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          "& .MuiPagination-ul": {
                            display: "flex",
                            justifyContent: "center",
                            flexGrow: 1,
                          },
                          "& .MuiPaginationItem-root": {
                            fontSize: "24px",
                          },
                          "& .MuiPaginationItem-page": {
                            height: 48,
                            width: 48,
                          },
                          "& .MuiPaginationItem-page.Mui-selected": {
                            backgroundColor: alpha(
                              theme.palette.primary.main,
                              0.5,
                            ),
                            color: "white",
                            height: 48,
                            width: 48,
                          },
                          "& .MuiPaginationItem-previousNext": {
                            border: "1px solid",
                            borderColor: theme.palette.lightGray.main,
                            height: 48,
                            width: 48,
                            "& svg": {
                              fontSize: "24px",
                            },
                          },
                        }}
                        count={
                          (data?.totalElements % size === 0
                            ? data?.totalElements / size
                            : Math.floor(data?.totalElements / size) + 1) || 0
                        }
                        shape="rounded"
                        size="small"
                        page={data?.number + 1 || 0}
                        onChange={(event, value) => {
                          handleChangePage(event, value - 1);
                        }}
                      />
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </Grid>

        {/* Desktop table */}
        <Grid
          item
          md={12}
          xs={12}
          sx={{
            height: "78vh",
            overflowY: "auto",
            display: { xs: "none", md: "block" },
          }}
        >
          <Table
            sx={{
              borderCollapse: "separate",
              borderSpacing: " 0 8px",
            }}
          >
            <TableHead
              sx={{
                position: "sticky",
                zIndex: 5,
                top: 0,
                backgroundColor: theme.palette.dashboardBackground.main,
                width: "100%",
              }}
            >
              <TableRow>
                <TableCell
                  style={{
                    textAlign: "left",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                  onClick={() => handleClickChangeOrderBy("dateCreated")}
                >
                  <Typography
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                    sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                  >
                    Created date
                    <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1, ml: "4px" }}>
                      <span style={{
                        fontSize: "10px",
                        lineHeight: "10px",
                        color: params?.orderBy === "dateCreated" && params?.orderDirection === "ASC" ? "#333" : "#ccc"
                      }}>▲</span>
                      <span style={{
                        fontSize: "10px",
                        lineHeight: "10px",
                        color: params?.orderBy === "dateCreated" && params?.orderDirection === "DESC" ? "#333" : "#ccc"
                      }}>▼</span>
                    </Box>
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    Client
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    User
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    Internal Reference
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    Direction
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    noWrap
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    Declarations
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    noWrap
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    Status
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    ELO number
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    Reference number
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "right",
                    color: "#8f8f8f",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    noWrap
                    variant={isMediumScreen ? "subtitle2" : "subtitle1"}
                  >
                    Actions
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading
                ? Array.from({ length: parseInt(params?.size) || 15 }).map(
                    (_, index) => (
                      <TableRow key={index} >
                        <TableCell colSpan={14} sx={{ padding: "12px 16px" }}>
                          <Skeleton
                            variant="rounded"
                            width="100%"
                            height={25}
                            animation="wave"
                          />
                        </TableCell>
                      </TableRow>
                    ),
                  )
                : data &&
                  data?.totalElements > 0 &&
                  data?.content?.map((item, index) => {
                    return (
                      <TableRow key={index} 
                        style={{backgroundColor: item?.seen === false ? "rgb(66 185 178 / 21%)" : ""}}
                        sx={{
                          transition: "transform 0.3s ease, box-shadow 0.3s ease",
                          transform: highlightedRow === item.id ? "translateY(-2px)" : "none",
                          boxShadow: highlightedRow === item.id
                            ? "0 8px 24px rgba(0,0,0,0.25)"
                            : "none",
                          outline: highlightedRow === item.id
                            ? "4px solid rgba(77, 77, 77, 0.37)"
                            : "none",
                          zIndex: highlightedRow === item.id ? 1 : 0,
                          position: "relative",
                        }}  
                      >
                        <TableCell>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "light" }}
                          >
                            {item?.dateCreated
                              ? moment(item?.dateCreated).format(
                                  "DD.MM.YYYY HH:mm",
                                )
                              : "N/A"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "light" }}
                          >
                            {`${item?.organization?.nameEn}`}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "light" }}
                          >
                            {`${item?.createdBy?.displayName ? item?.createdBy?.displayName : "N/A"}`}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ width: 150, maxWidth: 150 }}>
                          <Typography
                            variant="h5"
                            noWrap
                            sx={{
                              fontWeight: "light",
                              maxWidth: 150,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {`${item?.internalReference}`}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "light" }}
                          >
                            {`${item?.informationsAppairage?.sensTraversee}`}
                          </Typography>
                        </TableCell>
                        <TableCell>
                        {(() => {
                          const declarations = Array.isArray(
                            item?.identifiantsDeclaration,
                          )
                            ? item.identifiantsDeclaration
                            : item?.identifiantsDeclaration
                              ? String(item.identifiantsDeclaration)
                                  .split(",")
                                  .map((v) => v.trim())
                                  .filter(Boolean)
                              : [];

                          if (declarations.length === 0) {
                            return (
                              <Typography
                                sx={{
                                  fontSize: "16px",
                                  color: "text.secondary",
                                }}
                              >
                                N/A
                              </Typography>
                            );
                          }

                          const first = declarations[0];
                          const remaining = declarations.length - 1;

                          return (
                            <Tooltip
                              arrow
                              placement="top"
                              title={declarations.join("\n")}
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    fontSize: "14px",
                                    whiteSpace: "pre-line",
                                  },
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  cursor: "pointer",
                                }}
                              >
                                <Chip
                                  label={first}
                                  size="small"
                                  sx={{
                                    height: 20,
                                    fontSize: "16px",
                                    maxWidth: 150,
                                    backgroundColor: "white",
                                    "& .MuiChip-label": {
                                      px: 0.75,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    },
                                  }}
                                />

                                {remaining > 0 && (
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      color: "text.secondary",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    +{remaining}
                                  </Typography>
                                )}
                              </Box>
                            </Tooltip>
                          );
                        })()}
                      </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Chip
                            style={{ width: "80px" }}
                            label={item?.status ? item?.status : "N/A"}
                            color={
                              item?.status === "ERROR" ||
                              item?.status === "REJECTED"
                                ? "error"
                                : item?.status === "COMPLETED"
                                  ? "success"
                                  : "primary"
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "light" }}
                          >
                            {`${item?.eloNumber ? item?.eloNumber : "N/A"}`}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "light" }}
                          >
                            {`${item?.referenceNumber ? item?.referenceNumber : "N/A"}`}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          {item?.status && 
                          (item?.status === "COMPLETED" ||
                            item?.status === "EMBARKED" || 
                            item?.status === "DEBARKED" ||
                            item?.status === "PAIRED"
                          ) && (
                            <Tooltip title="Download ELO">
                              <IconButton
                                onClick={() => {
                                  handleDownloadElo(item?.id);
                                }}
                              >
                                <Icon
                                  style={{
                                    color: theme.palette.secondary.main,
                                  }}
                                  fontSize="medium"
                                >
                                  get_app
                                </Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip
                            title={LOCALE.edit}
                            aria-label={LOCALE.edit}
                          >
                            <IconButton
                              onClick={() => {
                                navigate(
                                  window.location.pathname +
                                    "/edit/" +
                                    item?.id,
                                );
                                sessionStorage.setItem("highlightedRow", item?.id);
                                setHighlightedRow(item?.id);
                              }}
                              style={{
                                    color: theme.palette.primary.main,
                                  }}
                              aria-label="edit"
                            >
                              <Icon fontSize="medium">open_in_new</Icon>
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>

            <TableFooter
              style={{
                position: "fixed",
                bottom: 0,
                zIndex: 5,
                backgroundColor: theme.palette.dashboardBackground.main,
                width: "100%",
              }}
            >
              <Grid container spacing={1} sx={{ display: "flex" }}>
                <Grid item xs={4}>
                  <TablePagination
                    sx={{
                      borderBottom: "none",
                      "& .MuiTablePagination-select": {
                        fontSize: isMediumScreen ? "12px" : "18px",
                        border: "1px solid",
                        borderColor: theme.palette.lightGray.main,
                        padding: isMediumScreen ? "5px 8px" : "5px 15px",
                        borderRadius: "4px",
                      },
                      "& .MuiTablePagination-displayedRows": {
                        marginLeft: "-15px",
                        fontSize: isMediumScreen ? "12px" : "15px",
                        color: theme.palette.lightGray.main,
                      },
                      "& .MuiTablePagination-actions button": {
                        fontSize: isMediumScreen ? "15px" : "20px",
                      },
                      "& .MuiIconButton-root": {
                        fontSize: isMediumScreen ? "15px" : "20px",
                      },
                      "& .MuiSelect-icon": {
                        fontSize: isMediumScreen ? "15px" : "20px",
                      },
                    }}
                    rowsPerPageOptions={
                      AuthRepository.hasAnyRole(["ROLE_ADMINISTRATION"])
                        ? [5, 10, 15, 25, 50, 75, 100]
                        : [5, 10, 15, 25]
                    }
                    rowsPerPage={params?.size ? params?.size : size}
                    labelDisplayedRows={() => `of ${data?.totalElements}`}
                    labelRowsPerPage={
                      <span
                        style={{
                          fontSize: isMediumScreen ? "12px" : "15px",
                          marginLeft: "-20px",
                          color: theme.palette.lightGray.main,
                        }}
                      >
                        {LOCALE.rows_per_page}
                      </span>
                    }
                    SelectProps={{
                      inputProps: {
                        fontSize: isMediumScreen ? "15px" : "20px",
                        "aria-label": LOCALE.rows_per_page,
                      },
                      native: true,
                    }}
                    onRowsPerPageChange={(event, value) => {
                      handleChangeRowsPerPage(event);
                    }}
                    page={data?.number || 0}
                    count={data?.totalElements || 0}
                    size="large"
                    ActionsComponent={() => null}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Pagination
                    sx={{
                      marginTop: "15px",
                      display: "flex",
                      justifyContent: "center",
                      "& .MuiPaginationItem-root": {
                        fontSize: isMediumScreen ? "15px" : "20px",
                      },
                      "& .MuiPaginationItem-page.Mui-selected": {
                        backgroundColor: theme.palette.secondary.main,
                        opacity: "50%",
                        color: "white",
                      },
                      "& .MuiPaginationItem-previousNext": {
                        border: "1px solid",
                        borderColor: theme.palette.lightGray.main,
                      },
                    }}
                    count={
                      (data?.totalElements % size === 0
                        ? data?.totalElements / size
                        : Math.floor(data?.totalElements / size) + 1) || 0
                    }
                    shape="rounded"
                    size={isMediumScreen ? "medium" : "large"}
                    page={data?.number + 1 || 0}
                    onChange={(event, value) => {
                      handleChangePage(event, value - 1);
                    }}
                  />
                </Grid>
              </Grid>
            </TableFooter>
          </Table>
        </Grid>
      </Grid>
      <Dialog
        open={openDateCreatedCalendar}
        onClose={() => {
          setOpenDateCreatedCalendar(false);
        }}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth={isSmallScreen ? "xs" : "lg"}
        hideBackdrop={true}
        style={{ textAlign: "right", marginTop: "90px" }}
      >
        <DateCreatedCalendar
          setOpenDateCreatedCalendar={setOpenDateCreatedCalendar}
          openDateCreatedCalendar={openDateCreatedCalendar}
          handleDateCreated={handleDateCreated}
          dateCreatedState={dateCreatedState}
          setDateCreatedState={setDateCreatedState}
        ></DateCreatedCalendar>
      </Dialog>
      <Outlet />
    </>
  );
};